import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary, ButtonSecondary } from '@spotify-internal/encore-web';
import AnchorAPI from '../../../../modules/AnchorAPI';

type Props = {
  type: 'verify' | 'pending' | 'publish';
  onResendEmail?: () => void;
  onClickClose(): void;
};

const EmailVerificationModal = ({
  onClickClose,
  onResendEmail,
  type,
}: Props) => {
  const [pendingEmail, setPendingEmail] = React.useState('');

  React.useEffect(() => {
    if (type === 'pending') {
      AnchorAPI.fetchPendingEmail().then(({ email }: { email: string }) => {
        setPendingEmail(email);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function content() {
    switch (type) {
      case 'verify':
        return (
          <span>
            Click the link in the email we just sent you to verify your new
            email address. Your account information will not be updated until
            you have verified this change.
          </span>
        );
      case 'pending':
        return (
          <span>
            Please click the link in the email we sent to{' '}
            <strong>{pendingEmail}</strong> to verify your new email address.
            Your account information will be updated once you’ve verified this
            change.
          </span>
        );
      case 'publish':
        return (
          <span>
            Before we can publish this episode, you’ll need to verify your email
            address. Just click the link in the email we sent you!
          </span>
        );
      default:
        return <span>no type specified</span>;
    }
  }
  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="email-verification-modal-title"
      onClose={onClickClose}
    >
      <Modal.Title id="email-verification-modal-title">
        Verify your email address
      </Modal.Title>
      <Modal.Body>{content()}</Modal.Body>
      <Modal.Footer className="buttonContainer">
        {onResendEmail && (
          <ButtonSecondary onClick={onResendEmail}>
            Resend email
          </ButtonSecondary>
        )}
        <ButtonPrimary onClick={onClickClose}>Got it, thanks</ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};

export { EmailVerificationModal };
